import {
    apiRequest,
    masterRegion
} from "../../../../../services/adapters/kepegawaian/penilaianService"

class IndexRepository {

    fetchRegion = async (query, cancelToken) => {
        return await apiRequest("get", masterRegion, {
            cancelToken: cancelToken,
            params: query
        }, true);
    }


    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

}

export default IndexRepository;